// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"2961c879","453":"8443fe18","876":"595a974a"}[chunkId] + ".chunk.js";
};